import React, { useEffect, useState } from "react";
import style from "../SearchResults/SearchResults.module.css";
import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import '../../components/headersStyling.css';
import Loading from "../../components/Loading/Loading";
import { useTranslation } from "react-i18next";
import searchNotfound from "../../assets/images/search2.png";
import { getAreaDetails, getCities } from "../../Api/commonApis";
import { filterProperties } from "../../Api/propertiesApi";
import { getAreas, getPropertyTypes } from '../../Api/commonApis';
import arrow from '../../assets/icons/dropdownarrow.svg';
import subtract from '../../assets/icons/subtract.svg';
import add from '../../assets/icons/add.svg';
import Propertycard from './../../components/propertyCard/propertycard';
import { filterLanguage } from './../../utilities/filterFunction';
import { basename } from './../../configiration/config';
import { useParams } from 'react-router-dom';
import { imgResize } from './../../utilities/imageResize';

function Locations() {
  let navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();
  const { slug } = useParams();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  var myDate = new Date();

  //add a day to the date
  myDate.setDate(myDate.getDate());
  const [checkinDate, setCheckinDate] = useState(new Date());
  const [checkoutDate, setCheckoutDate] = useState(myDate);
  const [minCheckoutDate, setMinCheckoutDate] = useState(myDate);

  let minDate = new Date();
  const [area, setArea] = useState({});
  const [selectedBeds, setSelectedBeds] = useState("");
  const [bedsDropHead, setBedsDropHead] = useState("");
  const [selectedBaths, setSelectedBaths] = useState("");
  const [bathsDropHead, setBathsDropHead] = useState("");
  const [sortingDropHead, setSortingDropHead] = useState(t('sort-by'));
  const [guestsValue, setGuestsValue] = useState(1);

  const [cities, setCities] = useState([]);
  const [areas, setAreas] = useState([]);
  const [types, setTypes] = useState([]);
  const [typeDropHead, setTypeDropHead] = useState("");
  const [areaDropHead, setAreaDropHead] = useState("");
  const [sortByOPtion, setsortByOPtion] = useState("");
  const [sortOPtion, setsortOPtion] = useState("");
  const [allProperties, setAllproperties] = useState();
  const [loading, setloading] = useState(true);
  const [base_url, setbase_url] = useState('');
  const [searchObj, setsearchObj] = useState({
    area:slug,
    type: "",
    bedrooms: selectedBeds,
    bathrooms: selectedBaths,
    min_price: "",
    max_price: "",
    checkIn: "",
    checkOut: "",
  });
useEffect(() => {
  setbase_url(`area=${searchObj && searchObj.area}&city=${area && area.city && area.city.slug}`)
},[searchObj,area])
    

  useEffect(() => {
    if (slug) {
      getAreaDetails(slug).then((res) => {
        let areaDetails = { ...area }
        areaDetails = res.data.data
        setAreaDropHead(
          areaDetails.locales ? filterLanguage(areaDetails.locales)[0].name : t("area")
        );
        filterProperties(`area=${slug}&city=${areaDetails && areaDetails.city && areaDetails.city.slug}`).then((res) => {
          let property = { ...allProperties };
          property = res.data.data;
          setAllproperties(property);
          setloading(false);
        });
        setArea(areaDetails)
      })
    }
    setTypeDropHead(t("property-type"));

    setCheckinDate(minDate);
    setCheckoutDate(checkoutDate);
    // eslint-disable-next-line
  }, [slug])

  useEffect(() => {
    let serachob = { ...searchObj };
    setsearchObj({
      ...serachob,
      bedrooms: selectedBeds,
      bathrooms: selectedBaths,
    });
    // eslint-disable-next-line
  }, [selectedBeds, selectedBaths]);

  // get cities
  useEffect(() => {
    getCities().then((res) => {
      let citiess = { ...cities };
      citiess = res.data.data;
      setCities(citiess);

      getAreas(citiess[0].slug).then((res) => {
        let area = { ...areas };
        area = res.data.data;
        setAreas(area);
      });
    });
    // eslint-disable-next-line
  }, []);
  // get types
  useEffect(() => {
    getPropertyTypes().then((res) => {
      let type = { ...types };
      type = res.data.data;
      setTypes(type);
    });
    // eslint-disable-next-line
  }, []);

  // handle inputs change
  function handleInputChange(e) {
    e.preventDefault();
    let search = { ...searchObj };
    if (e.target.name === "type") {
      setTypeDropHead(e.target.innerHTML);
      search[e.target.name] = e.target.id;
    }
    if (e.target.name === "area") {
      setAreaDropHead(e.target.innerHTML);
      search[e.target.name] = e.target.id;
    }
    if (
      e.target.name === "guests" ||
      e.target.name === "checkIn" ||
      e.target.name === "checkOut" ||
      e.target.name === "min_price" ||
      e.target.name === "max_price"
    ) {
      search[e.target.name] = e.target.value;
    }
    setsearchObj(search);
  }
  let search_url = `${base_url}&bedrooms=${searchObj.bedrooms}&bathrooms=${searchObj.bathrooms}&type=${searchObj.type}&min_price=${searchObj.min_price}&max_price=${searchObj.max_price}&sort=${sortOPtion}&by=${sortByOPtion}`;
  //search handler
  function searchSubmitHandler() {
    setloading(true);
    filterProperties(`${base_url}&bedrooms=${searchObj.bedrooms}&bathrooms=${searchObj.bathrooms}&type=${searchObj.type}&min_price=${searchObj.min_price}&max_price=${searchObj.max_price}&sort=${sortOPtion}&by=${sortByOPtion}`).then((res) => {
      let property = { ...allProperties };
      property = res.data.data;
      setAllproperties(property);
      setloading(false);
    }).catch((err) => {
      console.log(err.response);
    });

  }

  
  function checkdateAvailabilty() {
    let availabilty_url = `${search_url}&guests=${guestsValue}&check_in=${moment(checkinDate, [
      "h:mm A",
    ]).format("YYYY-MM-DD")}`
    if(moment(checkinDate, [ "h:mm A",]).format("YYYY-MM-DD") !== moment(checkoutDate, [ "h:mm A", ]).format("YYYY-MM-DD")){
      availabilty_url+=`&check_out=${moment(checkoutDate, [
        "h:mm A",
      ]).format("YYYY-MM-DD")}`
    }
    filterProperties(availabilty_url).then((res) => {
      let property = { ...allProperties };
      property = res.data.data;
      setAllproperties(property);
    })
      .catch((err) => {
        console.log(err.response);
      });
  }

  return (
    <div>
      {/* START OF HEADER SECTION */}
      {area && area.image ?
        <div
          className={`${style.searchHeader} myHeader d-flex align-items-center justify-content-center`}
          style={{ backgroundImage: `url(${imgResize(area && area.image,1920,455)})` }}
        >
          <div className={`${style.headerContent} myHeaderContent`}>
            <h1>{areaDropHead}</h1>
            <p>
              <span
                className="homeWord"
                onClick={() => {
                  navigate(`${basename}/`);
                }}
              >
                {t("home")}
              </span>{" "}
              / <span>{t("locations")}</span>{" "}
              <span className="locationWord"> / {areaDropHead}</span>
            </p>
          </div>
        </div>

        : <div className={`${style.searchHeader} myHeader d-flex align-items-center justify-content-center`}>
          <div className={`${style.headerContent} myHeaderContent`}>
            <h1>{areaDropHead}</h1>
            <p>
              <span
                className="homeWord"
                onClick={() => {
                  navigate(`${basename}/`);
                }}
              >
                {t("home")}
              </span>{" "}
              / <span>{t("locations")}</span>{" "}
              <span className="locationWord"> / {areaDropHead}</span>
            </p>
          </div>
        </div>
      }

      {/* END OF HEADER SECTION */}

      {/* START OF SEARCH PROJECTS */}

      {/* Search Section */}
      <div
        className={`${style.searchBar} d-flex align-items-center justify-content-center`}
      >
        <div className={`${style.myCustomContainer} my-5`}>
          <div className={` ${style.gridContainer} w-100`}>
            {/* Area Input Field */}
            <div
              className={`${style.textInput} ${style.mates} ${style.gridItem}`}
            >
              <div className="dropdown">
                <button
                  className="w-100 btn px-2 d-flex justify-content-between align-items-center placeholders"
                  type="button"
                  id="areaDropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span>{areaDropHead}</span>
                  <img src={arrow} alt='arrow' />
                </button>
                <ul className="dropdown-menu" aria-labelledby="areaDropdownMenuButton">
                  {areas && areas.length ? (
                    areas.map((area) => {
                      let selectedArea = filterLanguage(area.locales)
                      return (
                        <li key={area.id}>
                          <a
                            href={area.name}
                            id={area.slug}
                            name="area"
                            onClick={handleInputChange}
                            className='dropdown-item'
                          >
                            {selectedArea.length > 0 ? selectedArea[0].name : ''}
                          </a>
                        </li>
                      );
                    })
                  ) : (
                    <li>{t("no-data")}</li>
                  )}
                </ul>
              </div>
            </div>
            {/* Property Options */}
            <div
              className={`${style.propertyOptions} ${style.mates} ${style.gridItem}`}
            >
              <div className="dropdown">
                <button
                  className="w-100 btn px-2 d-flex justify-content-between align-items-center placeholders"
                  type="button"
                  id="propertyDropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span>{typeDropHead}</span>
                  <img src={arrow} alt='arrow' />
                </button>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="propertyDropdownMenuButton"
                >
                  {types && types.length ? types.map((type) => {
                    let selectedType = filterLanguage(type.locales)
                    return (
                      <li key={type.id}>
                        <a
                          href={type.name}
                          id={type.slug}
                          name="type"
                          onClick={handleInputChange}
                          className='dropdown-item'
                        >
                          {selectedType.length > 0 ? selectedType[0].name : ''}

                        </a>
                      </li>
                    );
                  })
                    : (
                      <li>{t("no-data")}</li>
                    )}
                </ul>
              </div>
            </div>
            {/* Beds && Bathrooms Options */}
            <div
              className={` ${style.bedsOptions} ${style.mates} ${style.gridItem}`}
            >
              <div className="dropdown">
                <button
                  className="w-100 btn d-flex justify-content-between align-items-center placeholders"
                  type="button"
                  id="bedsDropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span>
                    <span className={`${style.selectedBeds}`}>
                      {bedsDropHead}
                    </span>{" "}
                    {t("beds")} &{" "}
                    <span className={`${style.selectedBeds}`}>
                      {bathsDropHead}
                    </span>{" "}
                    {t("bath")}
                  </span>
                  <img src={arrow} alt='arrow' />
                </button>
                <ul
                  className="dropdown-menu w-100"
                  aria-labelledby="bedsDropdownMenuButton"
                >
                  <li className="dropdown-item">
                    <div className="">
                      <span></span>
                    </div>
                    <div className={`${style.bedNumbers}`}>
                      <button
                        onClick={() => {
                          setSelectedBeds("");
                          setBedsDropHead("");
                        }}
                      >
                        ANY
                      </button>
                      <button
                        onClick={(e) => {
                          setSelectedBeds(1);
                          setBedsDropHead(e.target.innerHTML);
                        }}
                      >
                        1
                      </button>
                      <button
                        onClick={(e) => {
                          setSelectedBeds(2);
                          setBedsDropHead(e.target.innerHTML);
                        }}
                      >
                        2
                      </button>
                      <button
                        onClick={(e) => {
                          setSelectedBeds(3);
                          setBedsDropHead(e.target.innerHTML);
                        }}
                      >
                        3
                      </button>
                      <button onClick={(e) => { setSelectedBeds(4); setBedsDropHead(e.target.innerHTML); }}
                      >4+
                      </button>
                    </div>
                  </li>
                  <li className="dropdown-item">
                    <div className="">
                      <span></span>
                      <span></span>
                    </div>
                    {/* bath numbers */}
                    <div className={`${style.bedNumbers}`}>
                      <button
                        onClick={() => {
                          setSelectedBaths("");
                          setBathsDropHead("");
                        }}
                      >
                        ANY
                      </button>
                      <button
                        onClick={(e) => {
                          setSelectedBaths(1);
                          setBathsDropHead(e.target.innerHTML);
                        }}
                      >
                        1
                      </button>
                      <button
                        onClick={(e) => {
                          setSelectedBaths(2);
                          setBathsDropHead(e.target.innerHTML);
                        }}
                      >
                        2
                      </button>
                      <button
                        onClick={(e) => {
                          setSelectedBaths(3);
                          setBathsDropHead(e.target.innerHTML);
                        }}
                      >
                        3
                      </button>
                      <button
                        onClick={(e) => {
                          setSelectedBaths(4);
                          setBathsDropHead(e.target.innerHTML);
                        }}
                      >
                        4+
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            {/* Pricing Options */}
            <div
              className={`${style.priceOptions} ${style.mates} ${style.gridItem}`}
            >
              <div className="dropdown">
                <button className="w-100 btn d-flex justify-content-between align-items-center placeholders"
                  type="button"
                  id="bedsDropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span>{t('price')} </span>
                  <img src={arrow} alt='arrow' />
                </button>
                <ul
                  className={`dropdown-menu  ${style.priceDropdown}`}
                  aria-labelledby="priceDropdownMenuButton"
                >
                  <li className="dropdown-item">
                    <div className='d-flex justify-content-between align-items-center'>
                      <input className="guestsInputFiled" type="number" min='1' placeholder="from" name="min_price" onChange={handleInputChange} /* onInput={(e)=>limitPriceNum('min',e)}  */ />  -
                      <input className="guestsInputFiled" type="number" min='1' placeholder="to" name="max_price" /* onInput={(e)=>limitPriceNum('max',e)} */ onChange={handleInputChange} />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            {/* Sorting Options */}
            <div
              className={`${style.sortingOptions} ${style.mates} ${style.gridItem}`}
            >
              <div className="dropdown">
                <button
                  className="w-100 btn px-2 d-flex justify-content-between align-items-center"
                  type="button"
                  id="sortingDropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <span>{sortingDropHead}</span>
                  <img src={arrow} alt='arrow' />
                </button>
                <ul
                  className="dropdown-menu"
                  aria-labelledby="sortingDropdownMenuButton"
                >
                  <li
                    onClick={(e) => {
                      setSortingDropHead(e.target.innerHTML);
                      setsortByOPtion("DESC");
                      setsortOPtion("created_at");
                    }}
                    className="dropdown-item d-flex"
                  >
                    {t('newest')}
                  </li>
                  <li
                    onClick={(e) => {
                      setSortingDropHead(e.target.innerHTML);
                      setsortByOPtion("ASC");
                      setsortOPtion("created_at");
                    }}
                    className="dropdown-item d-flex"
                  >
                    {t('oldest')}
                  </li>
                  <li
                    onClick={(e) => {
                      setSortingDropHead(e.target.innerHTML);
                      setsortByOPtion("DESC");
                      setsortOPtion("price");
                    }}
                    className="dropdown-item d-flex"
                  >
                    {t('highest-price')}
                  </li>
                  <li
                    onClick={(e) => {
                      setSortingDropHead(e.target.innerHTML);
                      setsortByOPtion("ASC");
                      setsortOPtion("price");
                    }}
                    className="dropdown-item d-flex"
                  >
                    {t('lowest-price')}
                  </li>
                </ul>
              </div>
            </div>
            {/* Find Button */}
            <div className={`${style.findBtn} ${style.pcFindBtn}`}>
              <button onClick={searchSubmitHandler}>{t('find')}</button>
            </div>
          </div>
          {/* Mobile Find Button */}
          <div className={`${style.findBtn} ${style.mobileFindBtn}`}>
            <button onClick={searchSubmitHandler}>{t('find')}</button>
          </div>
        </div>
      </div>

      {/* // Display Results */}
      <div className={`${style.myCustomContainer}  mx-auto mt-4 mb-5`}>
        <div className={`${style.resultsContainer} w-100 row mx-0`}>
          <div
            className={`${style.searchResults} row col-md-7 col-lg-9 order-md-1 order-2 g-3`}
          >
            {allProperties && allProperties.length
              ? allProperties.map((property) => {
                let selectedProperty = filterLanguage(property.locales)
                return (
                  <div
                    key={property.id}
                    className={`${style.propertyItem} col-md-12 col-lg-6`}
                  >
                    <Propertycard property={property} propertyLocales={selectedProperty} />
                  </div>
                );
              })
              : !loading && (
                <div className="noDataSection d-flex flex-column justify-content-center align-items-center">
                  <img src={searchNotfound} alt="search" />
                  <h5>{t('no-data')}</h5>
                </div>
              )}
            {loading && <Loading width="100px" height="100px" />}
          </div>

          <div
            className={`${style.aside} col-md-5 col-lg-3 order-md-2 order-1`}
          >
            <aside>
              <h5>{t("your-reservation")}</h5>
              <div className={`${style.reservationInputs}`}>
                <div
                  className={`${style.inputField} ${style.searchElement} d-flex align-items-start mb-3`}
                >
                  <span>{t("check-in")}</span>
                  <DatePickerComponent
                    className={`dropdown ${style.mates} e-input-group`}
                    id="datepicker"
                    format="E, d MMM y"
                    value={checkinDate}
                    min={minDate}
                    onFocus={(e) => e.target.blur()}
                    onChange={(d) => {
                      setCheckinDate(d.value);
                      setMinCheckoutDate(d.target.value);
                    }}
                  />
                </div>
                <div
                  className={`${style.inputField} ${style.searchElement} d-flex align-items-start mb-3`}
                >
                  <span>{t("check-out")}</span>
                  <DatePickerComponent
                    className={`dropdown ${style.mates} e-input-group`}
                    id="datepicker"
                    format="E, d MMM y"
                    value={checkoutDate}
                    min={minCheckoutDate}
                    onFocus={(e) => e.target.blur()}
                    onChange={(d) => setCheckoutDate(d.value)}
                  />
                </div>
                <div className={`${style.searchElement} mb-3`}>
                  <span>{t("guests")}</span>
                  <div className={`dropdown ${style.mates} position-relative`}>
                    <input
                      className="guestsInputFiled"
                      type="text"
                      readOnly
                      value={guestsValue}
                    />
                    <div
                      className={`${style.incrementSvgs} ${i18n.language === "ar"
                        ? style.incrementSvgsRight
                        : style.incrementSvgsLeft
                        }`}
                    >
                      <img src={subtract} alt='subtract' onClick={() => {
                        guestsValue > 1
                          ? setGuestsValue(guestsValue - 1)
                          : setGuestsValue(1);
                      }} />
                      <img src={add} alt='add' className={style.addIcon} onClick={() => {
                        guestsValue < 30 ?
                          setGuestsValue(Number(guestsValue) + 1)
                          : setGuestsValue(30);
                      }} />
                    </div>
                  </div>
                </div>
                <div
                  className={`${style.searchElement} ${style.SearchBtn} w-75 mx-auto`}
                >
                  <button className={`w-100`} onClick={checkdateAvailabilty}>
                    {t("check-availabilty")}
                  </button>
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>

      {/* END OF SEARCH PROJECTS */}
    </div>

    // </div>
  );
}

export default Locations;
